export default __webpack_public_path__ + "static/media/service-4.8fc2c4ed.svg";